import React from "react";

import * as S from "./styles";

// Battery-Only proposals never enter the design queue -- there is no array to lay out -- so
// this replaces the design-team and self-design notes rather than sitting alongside them.
const BatteryOnlyNotes = () => {
  return (
    <S.NoteContainer>
      <S.NoteSemiBoldFont>
        <S.BoldSpan>Battery proposal.</S.BoldSpan> Storage deals skip the design step entirely, so there is no designer
        to assign and no turnaround time to choose. Your proposal is created straight away.
      </S.NoteSemiBoldFont>
      <S.NoteSemiBoldFont>
        You can open it from the Project Proposals tab to pick equipment and finance options.
      </S.NoteSemiBoldFont>
    </S.NoteContainer>
  );
};

export default BatteryOnlyNotes;
